import ReactionComponent from './ReactionComponent';

export const commonComponents = {
  ReactionComponent,
};
